import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import axios from 'axios';
import BackToTop from 'vue-backtotop'
import VueTyperPlugin from 'vue-typer'
import 'bootstrap/dist/css/bootstrap.css'; // 引入 Bootstrap CSS
import 'bootstrap'; // 引入 Bootstrap JS
import 'jquery'; // 引入 jQuery
import 'popper.js'; // 引入 Popper.js
import SimpleHeader from '@/components/SimpleHeader.vue'

Vue.use(BackToTop)
Vue.use(ElementUI);
Vue.use(router)
Vue.use(VueTyperPlugin)

Vue.component('SimpleHeader', SimpleHeader);


// 设置 Axios 的基础 URL（可选）
axios.defaults.baseURL = '/api';

// 添加请求拦截器
axios.interceptors.request.use(config => {
  // 检查请求方法是否为 POST
  if (config.method === 'post' && config.data) {
    const formData = new FormData()

    // 将 config.data 中的所有参数添加到 FormData
    for (const key in config.data) {
      if (Object.prototype.hasOwnProperty.call(config.data, key)) {
        formData.append(key, config.data[key])
      }
    }

    // 将 FormData 赋值给 config.data
    config.data = formData
  }
  return config
}, error => {
  return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(response => {


  console.log('响应返回后:', response);
  return response;
}, error => {
  return Promise.reject(error);
});

Vue.prototype.$axios = axios;
Vue.config.productionTip = false


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
